export default function parseArrayFromUrlString(
  text?: string | null,
): Array<string> {
  if (!text) return [];
  try {
    return JSON.parse(decodeURIComponent(text));
  } catch (error) {
    console.log(error);
    return [];
  }
}
